export default __webpack_public_path__ + "static/media/spending.c3d60c7c.svg";